import { useEffect } from "react";
import { useLatestValue as s$1 } from "./use-latest-value.js";
function s(t, e, o, n) {
  let i = s$1(o);
  useEffect(() => {
    if (!t) return;
    function r(d) {
      i.current(d);
    }
    return window.addEventListener(e, r, n), () => window.removeEventListener(e, r, n);
  }, [t, e, n]);
}
export {
  s as useWindowEvent
};
